// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogContent,
  // DialogContentText,
  // DialogTitle,
  DialogActions,
  Button,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";
// import MDInput from "theme/components/MDInput";
// import MDBadge from "theme/components/MDBadge";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import DataTable from "theme/Tables/DataTable";
import usePageTitle from "app/pageTitle";
// import AppConfig from "appConfig";

function Course() {
  const pageTitle = "Sales Course";
  usePageTitle(pageTitle);

  const { id: reference } = useParams();
  const navigate = useNavigate();

  // const placeholderImg =
  //   "data:image/jpeg;base64,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";

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [course, setCourse] = useState(null);
  const [materials, setMaterials] = useState([]);
  const [tests, setTests] = useState([]);

  const [selectedMaterialContent, setSelectedMaterialContent] = useState({});
  const [openMaterialContentDialog, setOpenMaterialContentDialog] = useState(false);

  const tableTestsColumns = [
    { Header: "View", accessor: "action", align: "left" },
    { Header: "Assessment", accessor: "name", align: "left" },
    { Header: "Passed", accessor: "passed", align: "center" },
    // { Header: "Pass Mark", accessor: "pass_mark", align: "left" },
  ];

  const buildTestsRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        action: (
          <MDButton
            size="small"
            variant="contained"
            color="info"
            iconOnly
            circular
            onClick={() => {
              if (row.passed) {
                setSeverity("success");
                setErrMsg("You have already passed this quiz.");
                setOpen(true);
                return;
              }
              navigate(`/courses/tests/${row.reference}`);
            }}
          >
            <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
              visibility
            </Icon>
          </MDButton>
        ),
        name: (
          <span>
            <b>{row.title}</b>
            <br />
            <small>{`Pass Mark: ${row.pass_mark * 100}%`}</small>
          </span>
        ),
        passed: (
          <Icon color={row.passed ? "success" : "warning"}>
            {row.passed ? "check_circle" : "do_not_disturb"}
          </Icon>
        ),
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`agents/trainings/courses/${reference}`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setCourse(result.data.data.course);
            setMaterials(result.data.data.materials);
            const rows = buildTestsRows(result.data.data.tests);
            setTests(rows);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  function getContentLabel(record) {
    if (record.material_type === "VIDEO") {
      return "WATCH";
    }
    if (record.material_type === "FILE") {
      return "DOWNLOAD";
    }
    if (record.material_type === "TEXT") {
      return "READ";
    }

    return "VIEW CONTENT";
  }

  function getContentIcon(record) {
    if (record.material_type === "VIDEO") {
      return "ondemand_video";
    }
    if (record.material_type === "FILE") {
      return "file_download";
    }
    if (record.material_type === "TEXT") {
      return "description";
    }

    return "document";
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>

      <Dialog open={openMaterialContentDialog} fullWidth maxWidth="md">
        <DialogContent>
          <MDBox>
            {selectedMaterialContent.material_type === "VIDEO" ? (
              <iframe
                title="Video Tutorial"
                type="text/html"
                width="100%"
                height="480"
                src={selectedMaterialContent.material_content}
                frameBorder="0"
                allowFullScreen
              />
            ) : (
              <MDTypography variant="h6" fontWeight="light">
                <div
                  dangerouslySetInnerHTML={{ __html: selectedMaterialContent.material_content }}
                />
              </MDTypography>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenMaterialContentDialog(false);
            }}
            color="dark"
            variant="outlined"
            iconOnly
            circular
          >
            <Icon>close</Icon>
          </MDButton>
        </DialogActions>
      </Dialog>

      {course !== null && (
        <MDBox pt={3} pb={3}>
          <MDBox>
            <Button
              size="small"
              color="dark"
              startIcon={<Icon>west</Icon>}
              onClick={() => {
                navigate(`/courses`);
              }}
            >
              Back To Courses
            </Button>
          </MDBox>
          <MDBox mt={1}>
            <Card sx={{ width: "100%", marginTop: "15px" }}>
              <MDBox p={3}>
                <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                  Course
                </MDTypography>
                <MDTypography variant="h6" fontWeight="light" textTransform="capitalize">
                  {course.title}
                </MDTypography>
              </MDBox>
            </Card>
          </MDBox>

          <MDBox mt={5}>
            <Card sx={{ width: "100%", marginTop: "0px" }}>
              <MDBox p={3}>
                <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                  Course Outline
                </MDTypography>
                <MDTypography mt={2} fontSize="medium" fontWeight="light">
                  <div dangerouslySetInnerHTML={{ __html: course.description }} />
                </MDTypography>
              </MDBox>
            </Card>
          </MDBox>

          <MDBox mt={5}>
            <Card sx={{ height: "100%", marginTop: "0px" }}>
              <MDBox p={3}>
                <MDBox ml={0} mr={3}>
                  <MDTypography variant="h6" fontWeight="medium">
                    Course Materials
                  </MDTypography>
                  {/* <MDTypography variant="h6" fontWeight="light">
                          Go through the course materials to gain knowledge
                        </MDTypography> */}
                </MDBox>
                <MDBox mt={3}>
                  <Grid container spacing={3}>
                    {
                      // --> Notice below changes
                      materials.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                        materials.map((record) => (
                          <Grid item xs={6} md={4} lg={4}>
                            <MDBox align="left" sx={{ height: "100%", marginTop: "0px" }}>
                              <MDBox>
                                <MDTypography variant="h6" fontWeight="regular" mb={1}>
                                  {record.title}
                                </MDTypography>
                                <MDTypography mb={1}>
                                  <Icon fontSize="large">{getContentIcon(record)}</Icon>
                                </MDTypography>
                                <MDBox>
                                  <MDButton
                                    onClick={() => {
                                      if (["VIDEO", "TEXT"].includes(record.material_type)) {
                                        setSelectedMaterialContent(record);
                                        setOpenMaterialContentDialog(true);
                                      } else {
                                        window.open(record.material_content, "_blank");
                                      }
                                    }}
                                    color="info"
                                    variant="outlined"
                                    size="small"
                                  >
                                    {getContentLabel(record)}
                                  </MDButton>
                                </MDBox>
                              </MDBox>
                            </MDBox>
                          </Grid>
                        ))
                    }
                  </Grid>
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>

          <MDBox mt={5}>
            <Card sx={{ height: "100%", marginTop: "0px" }}>
              <MDBox p={3}>
                <MDBox ml={0} mr={3}>
                  <MDTypography variant="h6" fontWeight="medium">
                    Assessments
                  </MDTypography>
                  <MDTypography variant="h6" fontWeight="light">
                    Pass the assessment(s) to complete this course.
                  </MDTypography>
                </MDBox>
                <MDBox mt={5}>
                  <DataTable
                    table={{ columns: tableTestsColumns, rows: tests }}
                    isSorted
                    canSearch={false}
                    entriesPerPage={false}
                    showTotalEntries
                    noEndBorder
                  />
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>
        </MDBox>
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default Course;
